import { useMemo } from "react";

import { useParams, useSearchParams } from "react-router-dom";

import { parseHomeLocation } from "@/utils/UHomePath";

import { THomeLocation } from "@/types";

/** The home page as its URL describes it (see UHomePath). */
export const useHomeLocation = (): THomeLocation => {
	const params = useParams<{ viewId?: string; taskId?: string }>();
	const [search] = useSearchParams();
	const viewId = params.viewId;
	const taskId = params.taskId;
	const query = search.toString();
	return useMemo(
		() => parseHomeLocation({ viewId, taskId }, new URLSearchParams(query)),
		[viewId, taskId, query]
	);
};
